// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorIcon.error {
    position: absolute;
    top: 50%;
    left: 0;
    font-size: 0.821rem;
    font-weight: 600;
    transform: translateY(-50%);
    color: #ff3d71;
    font-style: normal;
}

.errorText {
    padding-left: 15px;
    left: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/error/error.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".errorIcon.error {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    font-size: 0.821rem;\r\n    font-weight: 600;\r\n    transform: translateY(-50%);\r\n    color: #ff3d71;\r\n    font-style: normal;\r\n}\r\n\r\n.errorText {\r\n    padding-left: 15px;\r\n    left: 60px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
